// extracted by mini-css-extract-plugin
export default {"product-image-picker":"product-image-picker_bFVrdux5","product-icon-image-grid":"product-icon-image-grid_zVOXF5BT","image-opacity":"image-opacity_qGAbMj_I"};